/**
 * Tiny event bus that lets any layer (TanStack Query global error handler,
 * raw fetches, etc.) signal "the current admin token is no longer valid;
 * kick the user back to login." App.tsx subscribes once at mount.
 *
 * We can't call into React state from arbitrary call sites, so this is the
 * smallest decoupling that gets us global 401 handling without a context.
 */

type Listener = () => void;
const listeners = new Set<Listener>();

export function emitUnauthorized(): void {
  for (const fn of listeners) fn();
}

export function onUnauthorized(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
